import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, Inject } from '@angular/core';
import { CommonService } from '../../../../services/common.service';
import { ShoppingCartService } from '../../../../services/shopping-cart.service';
import { CheckOutService } from '../../../../services/checkout.service';
import { CompleterData } from 'ng2-completer';
import { CheckoutViewModel, TenantViewModel, GetCSPTenant, TenantResponse, ProgramType } from '../../../../models/check-out.model';
// tslint:disable-next-line:import-blacklist
import { Subscription, Observable } from 'rxjs';
import { StateModel } from '../../../../models/account-ledger.model';
import { ApiResponse } from '../../../../models/api-response.model';
import { PostcodeList, SuburbList } from '../../../../models/account-delivery-address';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { DOCUMENT } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { TenantAssociationComponent } from '../../../../popup-collection/tenant-association-popup/tenant-association-popup.component';
import { AssociationInvitationComponent } from '../../../../popup-collection/association-invitation/association-invitation.component';
import { AuthService } from '../../../../services/auth.service';

declare var $: any;
declare var jquery: any;

@Component({
  selector: 'app-csp-tenant',
  templateUrl: './csp-tenant.component.html',
  styleUrls: ['./csp-tenant.component.css']
})
export class CspTenantComponent implements OnInit, OnDestroy {

  getTenantView: TenantViewModel;
  subscriptionRoute: Subscription;
  checkoutViewModel: CheckoutViewModel;
  subscriptionProgramTypes: string[];
  mpnList: string[];
  resellerMpnList: string[];
  selectedCSPTenant: GetCSPTenant;
  pcsp = 1;
  pady = 1;
  padm = 1;
  myControl = new FormControl();
  stateList: string[];
  searchTenantText: string;
  prefixText: string;
  domainName = '';
  domainTenantId: string;
  dataServicePostcode: CompleterData;
  postcodeSubData: Array<Object> = new Array<Object>();
  inputPostcode: string;
  inputSub: string;
  subData: Array<Object> = new Array<Object>();
  dataServiceSub: CompleterData;
  mpnIdSelect: string;
  resellerId: string;
  showUI = false;
  selectedTenantId: string;

  getCSPTenantList: GetCSPTenant[];
  filterCSPTenantList: GetCSPTenant[];
  getADYTenantList: GetCSPTenant[];
  filterADYTenantList: GetCSPTenant[];
  getADMTenantList: GetCSPTenant[];
  filterADMTenantList: GetCSPTenant[];
  userFormGroup: FormGroup;
 /*  filteredPostCode: SuburbList[];
  filteredSub: SuburbList[]; */
  filteredPostCodeFromAPI: PostcodeList[];
  filteredSubFromAPI: PostcodeList[];
  user_validation_messages: any = {
    'prefixField': [
      { class: 'domainPrefixValidate', message: 'Please enter domain prefix' }
    ],
    'firstNameField': [
      { class: 'firstNameValidate', message: 'Please enter first name' }
    ],
    'lastNameField': [
      { class: 'lastNameValidate', message: 'Please enter last name' }
    ],
    'emailField': [
      { class: 'emailValidate', message: 'Please enter email' }
    ],
    'companyNameField': [
      { class: 'companyNameValidate', message: 'Please enter company name' }
    ],
    'companyDescField': [
      { class: 'companyDescriptionValidate', message: 'Please enter company description' }
    ],
    'addressLine1Field': [
      { class: 'addressLine1Validate', message: 'Please enter address' }
    ],
    'suburbField': [
      { class: 'suburbValidate', message: 'Please enter suburb' }
    ],
    'stateField': [
      { class: 'addressLine1Validate', message: 'Please choose state' }
    ],
    'postcodeField': [
      { class: 'postcodeValidate', message: 'Please enter postcode' }
    ],
    'phoneField': [
      { class: 'phoneValidate', message: 'Please enter phone' }
    ],

  };
  userFormAssociateGroup: FormGroup;
  user_validation_associate_messages: any = {
    'domain': [
      { class: 'domainValidate', message: 'Please enter valid company domain' }
    ],
    'associateCompanyName': [
      { class: 'associateCompanyNameValidate', message: 'Please enter company name' }
    ],
    'associateEmail': [
      { class: 'associateEmailValidate', message: 'Please enter email address' }
    ]
  };

  @Input() cartId: string;
  @Input() proType: string;
  @Input() idx: number;
  @Output() selectCSPTenantEvent = new EventEmitter<GetCSPTenant>();
  @Output() selectADMTenantEvent = new EventEmitter<GetCSPTenant>();
  @Output() selectADYTenantEvent = new EventEmitter<GetCSPTenant>();
  @Output() selectINTATenantEvent = new EventEmitter<GetCSPTenant>();
  @Output() selectMpnIdEvent = new EventEmitter<string>();
  @Output() getCSPTenantViewEvent = new EventEmitter<TenantViewModel>();
  comparedValue = 'select';
  @ViewChild('myAutocompleteTriggerSub') private _myAutocompleteTriggerSub: MatAutocompleteTrigger;
  @ViewChild('myAutocompleteTriggerPostcode') private _myAutocompleteTriggerPostcode: MatAutocompleteTrigger;
  constructor(
    private commonService: CommonService,
    private shoppingCartService: ShoppingCartService,
    private checkOutService: CheckOutService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    @Inject(DOCUMENT) private _document: Document,
    public dialog: MatDialog
  ) {
    this.userFormGroup = this.formBuilder.group({
      userGroup: this.getUserGroup(),
      adTenantGroup: this.getAdTenantGroup()
    });
    this.userFormAssociateGroup = this.formBuilder.group({
      domain: new FormControl('', Validators.compose([Validators.required])),
      companyId: new FormControl({ value: '', disabled: true }),
      associateCompanyName: new FormControl('', Validators.compose([Validators.required])),
      associateEmail: new FormControl('', this.commonService.emailValidatorRegex()),
      associateCancelCC: new FormControl(false),
    });
  }

  // ngAfterViewChecked() {
  //   if (this.getTenantView && this.getTenantView.tenantId) {
  //     this.selectedTenantId = this.getTenantView.tenantId;

  //   }

  //   if (this.getTenantView && this.getTenantView.partnerId) {
  //     this.mpnIdSelect = this.getTenantView.partnerId;
  //   }
  // }

  ngOnInit() {

    this.commonService.foundationService();

    this.checkOutService.GetCSPTenantView(this.proType, this.commonService.toNumber(this.cartId)).subscribe((res: TenantViewModel) => {
      this.getTenantView = res;
      this.selectedTenantId = this.getTenantView.tenantId;
      this.mpnIdSelect = this.getTenantView.partnerId;
      this.mpnList = this.getTenantView.mpnList;
      if (this.mpnList && this.mpnList.length) {
        this.selectMpnIdEvent.emit(this.mpnList[0]);
      }
      this.getCSPTenantViewEvent.emit(this.getTenantView);
      this.checkOutService.GetCSPTenantListView(this.proType).subscribe((rep: GetCSPTenant[]) => {
        switch (this.proType) {
          case ProgramType[ProgramType.CSP]:
            this.getCSPTenantList = rep;
            this.filterCSPTenantList = this.getCSPTenantList;
            this.getCSPTenantList.forEach(tenant => {
              if (tenant.out_tenant_id === this.selectedTenantId) {
                this.selectCSPTenantEvent.emit(tenant);
              }
            });
            break;
          case ProgramType[ProgramType.ADM]:
            this.getADMTenantList = rep;
            this.filterADMTenantList = this.getADMTenantList;
            this.getADMTenantList.forEach(tenant => {
              if (tenant.out_tenant_id === this.selectedTenantId) {
                this.selectADMTenantEvent.emit(tenant);
              }
            });
            break;
          case ProgramType[ProgramType.ADY]:
            this.getADYTenantList = rep;
            this.filterADYTenantList = this.getADYTenantList;
            this.getADYTenantList.forEach(tenant => {
              if (tenant.out_tenant_id === this.selectedTenantId) {
                this.selectCSPTenantEvent.emit(tenant);
              }
            });
            break;
        }

        this.showUI = true;
      },
        (error: any) => {
          console.error(error);
        });
    },
      (error: any) => {
        console.error(error);
    });

      if (this.proType !== 'CSP') {
        this.checkOutService.GetSubscriptionTenantView(this.proType, this.commonService.toNumber(this.cartId)).subscribe((res: TenantViewModel) => {
          this.resellerMpnList = res.mpnList;

          if (!res.mpnList || res.mpnList.length < 1) { this.resellerMpnList = this.mpnList; }

          if (this.resellerMpnList && this.resellerMpnList.length) {
            this.resellerId = this.resellerMpnList[0];
          }
        },
          (error: any) => {
            console.error(error);
          });
      }

    this.shoppingCartService.getState().subscribe((res: StateModel) => {
      this.stateList = res.states;
    },
      (error: any) => {
        console.error(error);
      });
  }

  ngOnDestroy() {
    this.showUI = false;
  }

  searchTenant(type: string): void {
    switch (this.proType) {
      case ProgramType[ProgramType.CSP]:
        this.filterCSPTenantList = this.getCSPTenantList.filter(
          x => x.out_company_name.includes(this.searchTenantText) ||
            x.out_address_1.includes(this.searchTenantText) ||
            x.out_address_2.includes(this.searchTenantText) ||
            x.out_address_3.includes(this.searchTenantText) ||
            x.out_city.includes(this.searchTenantText) ||
            x.out_region.includes(this.searchTenantText) ||
            x.out_post_code.includes(this.searchTenantText) ||
            x.out_phone.includes(this.searchTenantText) ||
            x.out_email.includes(this.searchTenantText) ||
            x.out_prefix.includes(this.searchTenantText));
        break;
      case ProgramType[ProgramType.ADM]:
        this.filterADMTenantList = this.getADMTenantList.filter(
          x => x.out_company_name.includes(this.searchTenantText) ||
            x.out_address_1.includes(this.searchTenantText) ||
            x.out_address_2.includes(this.searchTenantText) ||
            x.out_address_3.includes(this.searchTenantText) ||
            x.out_city.includes(this.searchTenantText) ||
            x.out_region.includes(this.searchTenantText) ||
            x.out_post_code.includes(this.searchTenantText) ||
            x.out_email.includes(this.searchTenantText) ||
            x.out_prefix.includes(this.searchTenantText));
        break;
      case ProgramType[ProgramType.ADY]:
        this.filterADYTenantList = this.getADYTenantList.filter(
          x => x.out_company_name.includes(this.searchTenantText) ||
            x.out_address_1.includes(this.searchTenantText) ||
            x.out_address_2.includes(this.searchTenantText) ||
            x.out_address_3.includes(this.searchTenantText) ||
            x.out_city.includes(this.searchTenantText) ||
            x.out_region.includes(this.searchTenantText) ||
            x.out_post_code.includes(this.searchTenantText) ||
            x.out_email.includes(this.searchTenantText) ||
            x.out_prefix.includes(this.searchTenantText));
        break;
    }
  }

  selectCSPTenant(tenantId: string, getTenant: GetCSPTenant): void {
    this.selectedTenantId = tenantId;
    this.selectedCSPTenant = getTenant;

    if (getTenant?.out_status === 'SA') {
      this.dialog.open(AssociationInvitationComponent, {
        width: '630px',
        disableClose: true,
        panelClass: 'mat-dialog-wrapper',
      })
        .afterClosed()
        .subscribe(() => {
          this.getCSPTenantList = [] as GetCSPTenant[];
          this.ngOnInit();
        });
    }

    this.selectCSPTenantEvent.emit(this.selectedCSPTenant);
  }

  chooseAutoComplete(option: PostcodeList): void {
    this.userFormGroup.get('userGroup.postcodeField').setValue(option.postcode);
    this.userFormGroup.get('userGroup.stateField').setValue(option.state);
    this.userFormGroup.get('userGroup.suburbField').setValue(option.suburb);
  }

  chooseAutoCompletPostcode(event: any): void {
    if (this.filteredPostCodeFromAPI) {
      this.userFormGroup.get('userGroup.postcodeField').setValue(this.filteredPostCodeFromAPI.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('userGroup.stateField').setValue(this.filteredPostCodeFromAPI.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('userGroup.suburbField').setValue(this.filteredPostCodeFromAPI.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  chooseAutoCompletSuburb(event: any): void {
    if (this.filteredSubFromAPI) {
      this.userFormGroup.get('userGroup.postcodeField').setValue(this.filteredSubFromAPI.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('userGroup.stateField').setValue(this.filteredSubFromAPI.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('userGroup.suburbField').setValue(this.filteredSubFromAPI.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  startFilterSub(): void {
    if (this.userFormGroup.get('userGroup.suburbField').value.length > 2) {
      var postCodeSearchKey = ''; 
      this.authService.GetPostCodeList(this.userFormGroup.get('userGroup.suburbField').value, postCodeSearchKey).subscribe((res: PostcodeList[]) => {
        this.filteredSubFromAPI = res;
      },
        (error: any) => {
          console.error(error);
        });
    }
  }

  startFilterPostcode(): void {
    if (this.userFormGroup.get('userGroup.postcodeField').value.length > 1) {
      var suburbSearchKey = ''; 
      this.authService.GetPostCodeList(suburbSearchKey, this.userFormGroup.get('userGroup.postcodeField').value).subscribe((res: PostcodeList[]) => {
        this.filteredPostCodeFromAPI = res;
      },
        (error: any) => {
          console.error(error);
        });
    }
  }

  onInputSub(event: KeyboardEvent): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerSub._onChange(target.value);
    }
  }

  onInputPostcode(event: KeyboardEvent): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerPostcode._onChange(target.value);
    }
  }

  selectNoneCSPTenant(tenantId: string, programType: string, getTenant: GetCSPTenant): void {
    this.selectedTenantId = tenantId;
    switch (programType) {
      case ProgramType[ProgramType.ADM]:
        this.selectADMTenantEvent.emit(getTenant);
        break;
      case ProgramType[ProgramType.ADY]:
        this.selectADYTenantEvent.emit(getTenant);
        break;
    }
  }

  checkPrefix(): void {
    if (this.userFormGroup.get('userGroup.prefixField').valid) {
      this.checkOutService.CheckPrefix(this.userFormGroup.get('userGroup.prefixField').value).subscribe((res: ApiResponse) => {
        if (res && res.status) {
          this.commonService.showSuccess('.domainPrefixValidate', res.responseMessage, 'bottom');
        } else {
          this.commonService.showError('.domainPrefixValidate', res.responseMessage, 'bottom');
        }
      },
        (error: any) => {
          console.error(error);
        });
    } else if (this.userFormGroup.get('userGroup.prefixField').hasError('pattern')) {
      this.commonService.showError('.domainPrefixValidate', 'Domain names can only contain letters and numbers', 'bottom');
    } else if (this.userFormGroup.get('userGroup.prefixField').hasError('required')) {
      this.commonService.showError('.domainPrefixValidate', 'Please enter valid company domain', 'bottom');
    }
  }

  getUserGroup(): FormGroup {
    return this.formBuilder.group({
      prefixField: new FormControl('', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9]+$')])),
      firstNameField: new FormControl('', Validators.compose([Validators.required])),
      lastNameField: new FormControl('', Validators.compose([Validators.required])),
      emailField: new FormControl('', this.commonService.emailValidatorRegex()),
      userNameField: new FormControl({ value: 'admin', disabled: true }, Validators.required),
      companyNameField: new FormControl('', Validators.compose([Validators.required])),
      addressLine1Field: new FormControl('', Validators.compose([Validators.required])),
      addressLine2Field: new FormControl(''),
      addressLine3Field: new FormControl(''),
      suburbField: new FormControl('', Validators.compose([Validators.required])),
      stateField: new FormControl('', Validators.compose([Validators.required])),
      postcodeField: new FormControl('', Validators.compose([Validators.required])),
      phoneField: new FormControl('', Validators.compose([Validators.required]))
    });
  }

  getAdTenantGroup(): FormGroup {
    return this.formBuilder.group({
        // prefixField: new FormControl("", Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9]+$')])),
        firstNameField: new FormControl('', Validators.compose([Validators.required])),
        lastNameField: new FormControl('', Validators.compose([Validators.required])),
        emailField: new FormControl('', this.commonService.emailValidatorRegex()),
        companyNameField: new FormControl('', Validators.compose([Validators.required])),
        companyDescField: new FormControl('', Validators.compose([Validators.required])),
        addressLine1Field: new FormControl('', Validators.compose([Validators.required])),
        addressLine2Field: new FormControl(''),
        addressLine3Field: new FormControl(''),
        suburbField: new FormControl('', Validators.compose([Validators.required])),
        stateField: new FormControl('', Validators.compose([Validators.required])),
        postcodeField: new FormControl('', Validators.compose([Validators.required])),
        phoneField: new FormControl('', Validators.compose([Validators.required])),
        programType: new FormControl('')
    });
  }

  createEndUser(): void {
    if (this.userFormGroup.get('userGroup').valid) {
      let flag = false;
      if (this.userFormGroup.get('userGroup.postcodeField').value.length < 4) {
        flag = true;
        this.commonService.showValidator('.postcodeValidate', 'Please input valid postcode', 'right', 'error');
      }
      if (!flag) {
        this.checkOutService.CreateCSPTenant(JSON.stringify(this.userFormGroup.get('userGroup').value)).subscribe((res: TenantResponse) => {

        },
          (error: any) => {
            console.error(error);
            this.commonService.showError('.saveuser', error.responseMessage, 'bottom');
          });
      }
    } else {
      this.isNotValidField('userGroup.prefixField', this.user_validation_messages.prefixField);
      this.isNotValidField('userGroup.firstNameField', this.user_validation_messages.firstNameField);
      this.isNotValidField('userGroup.lastNameField', this.user_validation_messages.lastNameField);
      this.isNotValidField('userGroup.emailField', this.user_validation_messages.emailField);
      this.isNotValidField('userGroup.companyNameField', this.user_validation_messages.companyNameField);
      this.isNotValidField('userGroup.addressLine1Field', this.user_validation_messages.addressLine1Field);
      this.isNotValidField('userGroup.suburbField', this.user_validation_messages.suburbField);
      this.isNotValidField('userGroup.stateField', this.user_validation_messages.stateField);
      this.isNotValidField('userGroup.postcodeField', this.user_validation_messages.postcodeField);
      this.isNotValidField('userGroup.phoneField', this.user_validation_messages.phoneField);
    }

    this.checkOutService.GetCSPTenantListView(this.proType).subscribe((res: GetCSPTenant[]) => {
      switch (this.proType) {
        case ProgramType[ProgramType.CSP]:
          this.getCSPTenantList = res;
          this.filterCSPTenantList = this.getCSPTenantList;
          break;
        case ProgramType[ProgramType.ADM]:
          this.getADMTenantList = res;
          this.filterADMTenantList = this.getADMTenantList;
          break;
        case ProgramType[ProgramType.ADY]:
          this.getADYTenantList = res;
          this.filterADYTenantList = this.getADYTenantList;
          break;
      }
    },
      (error: any) => {
        console.error(error);
      });
  }

  createADEndUser(): void {

    if (this.userFormGroup.get('adTenantGroup').valid) {
      this.userFormGroup.get('adTenantGroup').patchValue({
        programType: this.proType
      });
      const formData = JSON.stringify(this.userFormGroup.get('adTenantGroup').value);
      this.checkOutService.CreateADTenant(formData).subscribe((data: TenantResponse) => {
           if (data.result === 'Success') {
             this.commonService.implementToast(data.info, 'Success');
             const tenantId = data.tenantId;

              this.checkOutService.GetCSPTenantListView(this.proType).subscribe((res: GetCSPTenant[]) => {
                let newTenant = {} as GetCSPTenant;

                switch (this.proType) {
                  case ProgramType[ProgramType.CSP]:
                    this.getCSPTenantList = res;
                    this.filterCSPTenantList = this.getCSPTenantList;
                    break;
                  case ProgramType[ProgramType.ADM]:
                    this.getADMTenantList = res;
                    this.filterADMTenantList = this.getADMTenantList;
                    newTenant = this.getADMTenantList.filter(x => x.out_tenant_id === tenantId)[0];
                    break;
                  case ProgramType[ProgramType.ADY]:
                    this.getADYTenantList = res;
                    this.filterADYTenantList = this.getADYTenantList;
                    newTenant = this.getADYTenantList.filter(x => x.out_tenant_id === tenantId)[0];
                    break;
                }
                // show the tenant list
                $('#li_select_tenant').click();
                this.comparedValue = 'select';
                // select new tenant
                this.selectNoneCSPTenant(tenantId, this.proType, newTenant);
              },
                (error: any) => {
                  console.error(error);
                });
           } else {
             this.commonService.implementToast(data.info, 'Error');
           }
      },
      (error: any) => {
        console.error(error);
      });

    } else {
      this.isNotValidField('adTenantGroup.firstNameField', this.user_validation_messages.firstNameField);
      this.isNotValidField('adTenantGroup.lastNameField', this.user_validation_messages.lastNameField);
      this.isNotValidField('adTenantGroup.emailField', this.user_validation_messages.emailField);
      this.isNotValidField('adTenantGroup.companyNameField', this.user_validation_messages.companyNameField);
      this.isNotValidField('adTenantGroup.companyDescField', this.user_validation_messages.companyDescField);
      this.isNotValidField('adTenantGroup.addressLine1Field', this.user_validation_messages.addressLine1Field);
      this.isNotValidField('adTenantGroup.suburbField', this.user_validation_messages.suburbField);
      this.isNotValidField('adTenantGroup.stateField', this.user_validation_messages.stateField);
      this.isNotValidField('adTenantGroup.postcodeField', this.user_validation_messages.postcodeField);
      this.isNotValidField('adTenantGroup.phoneField', this.user_validation_messages.phoneField);
    }
  }

  getTenantIdByDomain(): void {

    if (this.userFormAssociateGroup.get('domain').value) {
      this.checkOutService.GetTenantIdByDomain(this.userFormAssociateGroup.get('domain').value).subscribe((res: TenantResponse) => {
        if (res.result === 'Success') {
          this.userFormAssociateGroup.get('companyId').setValue(res.tenantId);
          this.commonService.showSuccess('.companyIdValidate', 'Company ID from Microsoft found by the given Domain', 'bottom');

        } else {
          this.commonService.showError('.companyIdValidate', res.info, 'bottom');

        }
      },
        (error: any) => {
          console.error(error);

        });
    } else {
      this.isNotValid('domain', this.user_validation_associate_messages.domain);

    }
  }

  selectMpnId(): void {
    this.selectMpnIdEvent.emit(this.mpnIdSelect);
  }

  associateEndUser(): void {
    if (this.userFormAssociateGroup.valid) {
      this.checkOutService.AssociateCSPTenant(encodeURIComponent(JSON.stringify(this.userFormAssociateGroup.getRawValue()))).subscribe((res: TenantResponse) => {
        if (res.result === 'Success') {

          // link the tenant for 'next' button
          this.checkOutService.GetCSPTenantListView(this.proType).subscribe((response: GetCSPTenant[]) => {
            response.forEach(tenant => {
              if (tenant.out_tenant_id === this.userFormAssociateGroup.get('companyId').value) {
                this.selectCSPTenantEvent.emit(tenant);
              }
            });
          },
            (error: any) => {
              console.error(error);
            }
          );

          this.commonService.showSuccess('.saveuser', res.info, 'bottom');
          this.dialog.open(TenantAssociationComponent, {
            width: '650px',
            data: {
              tenantId: this.userFormAssociateGroup.get('companyId').value,
              companyName: this.userFormAssociateGroup.get('associateCompanyName').value,
              tenantDomain: this.userFormAssociateGroup.get('domain').value,
              tenantEmail: this.userFormAssociateGroup.get('associateEmail').value
            }
          });
          this.checkOutService.GetCSPTenantListView(this.proType).subscribe((response: GetCSPTenant[]) => {
            response.forEach(tenant => {
              if (tenant.out_tenant_id === this.userFormAssociateGroup.get('companyId').value) {
                this.selectCSPTenantEvent.emit(tenant);
              }
            });
          },
            (error: any) => {
              console.error(error);
            }
          );
          
          // $('#divTenantAssociationPopup #tenant_details').find('#TenantID').html(this.userFormAssociateGroup.get('companyId').value);
          // $('#divTenantAssociationPopup #tenant_details').find('#CompanyName').html(this.userFormAssociateGroup.get('associateCompanyName').value);
          // $('#divTenantAssociationPopup #tenant_details').find('#TenantDomain').html(this.userFormAssociateGroup.get('domain').value);
          // $('#divTenantAssociationPopup #tenant_details').find('#TenantEmail').html(this.userFormAssociateGroup.get('associateEmail').value);
          // $('#divTenantAssociationPopup').foundation('open');
        } else {
          this.commonService.showError('.saveuser', res.info, 'bottom');
        }

      },
        (error: any) => {
          console.error(error);
        });

    } else {
      this.isNotValid('domain', this.user_validation_associate_messages.domain);
      this.isNotValid('associateCompanyName', this.user_validation_associate_messages.associateCompanyName);
      this.isNotValid('associateEmail', this.user_validation_associate_messages.associateEmail);

    }
  }

  isNotValidField(path: string, validation: any): void {
    if (path === 'userGroup.email') {
      if (this.userFormGroup.get(path).hasError('required')) {
        this.commonService.showValidator('.' + validation[0].class, validation[0].message, 'right', 'error');
      } else if (this.userFormGroup.get(path).hasError('email')) {
        this.commonService.showValidator('.' + validation[0].class, 'Please enter a valid email address', 'right', 'error');
      }
    } else {
      if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator('.' + validation[0].class, validation[0].message, 'right', 'error');
      }
    }
  }

  isNotValid(path: string, validation: any): void {
    if (path === 'associateEmail') {
      if (this.userFormAssociateGroup.get(path).hasError('required')) {
        this.commonService.showValidator('.' + validation[0].class, validation[0].message, 'bottom', 'error');
      } else if (this.userFormAssociateGroup.get(path).hasError('email')) {
        this.commonService.showValidator('.' + validation[0].class, 'Please enter a valid email address', 'bottom', 'error');
      }
    } else {
      if (!this.userFormAssociateGroup.get(path).valid) {
        this.commonService.showValidator('.' + validation[0].class, validation[0].message, 'bottom', 'error');
      }
    }
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  showAutoCompletePanel(trigger: any): void {
    trigger.openPanel();
  }

  closeTenantPopup(): void {
    $('#tenantmodal').foundation('close');
  }

  checkRadioButton(comparedValue: string) {
    this.comparedValue = comparedValue;
    // hide the next button when creating new tenant
    if (this.comparedValue === 'create') {
      $('#tenant_next').hide();
    } else {
      $('#tenant_next').show();
    }
  }
  omit_nonprintable_char(event: any) {
    event.target.value = this.commonService.omit_nonprintable_char(event.target.value);
    if (event.target.id == "addressLine1") {
      this.userFormGroup.get('userGroup.addressLine1Field').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine2") {
      this.userFormGroup.get('userGroup.addressLine2Field').setValue(event.target.value);
    }
    else if (event.target.id == "addressLine3") {
      this.userFormGroup.get('userGroup.addressLine3Field').setValue(event.target.value);
    }
  }
  closeAssociatePopup(): void {
    $('#divTenantAssociationPopup').foundation('close');
  }
}
